import React from "react";
import TitoloColore from "../commons/TitoloColore";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import Space from "../commons/Space";


function VisiteMediche() {
    return(
        <div>
            <div className="text-center" style={{backgroundColor: "#032041" ,color: "white"}}>
                <TitoloColore title={"Visite mediche"} backgroundColor={`#003F83`} />
                <h3 >Visite mediche direttamente qui </h3>
                <h5> Per appuntamenti 022426191 </h5>
                <Space />
                <Space />
            </div>
            <ScrollToTopOnMount />
        </div>
    )
}

export default VisiteMediche